export default __webpack_public_path__ + "static/media/profits.31fd9249.svg";